import { RentalDetailsPackOptionSelectionItem } from
    "../../../../Models/Rental/Details/RentalDetailsPackOptionSelectionItem";
import { RentDetailsProdOptItemSelectSection } from "./RentDetailsProdOptItemSelectSection";
import { PriceHelper } from "../../../../Lib/Helper/PriceHelper";
import { AxCounter } from "../../../../Limestone/AxCounter/AxCounter";
import { LocalizationModule } from "../../../Global/LocalizationModule";
import { AxLoad } from "../../../../Lib/AxSystem/AxLoad";
import { RentalProductDetails } from "../RentalProductDetails";

export class RentDetailsPackItemSelectionSection {
    private projNr: number;
    private prodGroupId: number;
    private packageId: number;
    private personTypeId: number;
    private packagesSelectedCount: number;
    private basePrice: number = 0;

    availableOptionalItems: RentalDetailsPackOptionSelectionItem[];
    optionalItemsSections: RentDetailsProdOptItemSelectSection[];

    private basePriceHolder: HTMLElement;
    private totalPriceHolder: HTMLElement;

    private priceHelper: PriceHelper;

    constructor(wrapperElement: HTMLElement, packageList: any) {
        this.packagesSelectedCount = 0;
        this.availableOptionalItems = [];
        this.optionalItemsSections = [];

        this.projNr = parseInt(wrapperElement.getAttribute("data-pack-projNr"));
        this.prodGroupId = parseInt(wrapperElement.getAttribute("data-pack-productGroupIdentifier"));
        this.packageId = parseInt(wrapperElement.getAttribute("data-pack-id"));
        this.personTypeId = parseInt(wrapperElement.getAttribute("data-pack-personTypeId"));

        this.addOptionalItemDataAndBasePrice(packageList);
        this.initPackageCounters();

        const localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
        this.priceHelper = new PriceHelper(localizationModule.getCultureInfo(), true);

        this.basePriceHolder = document.querySelector(`[data-item-basePrice-idendifier="${this.packageId}"]`);
        this.totalPriceHolder = document.querySelector(`[data-item-priceSum-idendifier="${this.packageId}"]`);
    }

    getPostData(): any {
        let postData = [];

        if (this.optionalItemsSections.length === 0) {
            for (let i = 0; i < this.getPackagesSelectedCount(); i++) {
                const packageSelectionData = {
                    projNr: this.projNr,
                    prodGrpId: this.prodGroupId,
                    packageId: this.packageId,
                    rentalPersonTypeId: this.personTypeId
                };

                postData.push(packageSelectionData);
            }

            return postData;
        }

        for (let i = 0; i < this.optionalItemsSections.length; i++) {
            const packageSelectionData = {
                projNr: this.projNr,
                prodGrpId: this.prodGroupId,
                packageId: this.packageId,
                rentalPersonTypeId: this.personTypeId,
                selectedOptionalItems: this.optionalItemsSections[i].getSelectedItemsIds()
            };

            postData.push(packageSelectionData);
        }

        return postData;
    }

    updateBasePriceLabel() {
        const localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
        const basePriceLabelText = this.priceHelper.GetPriceStringWithCurrencySymbol(this.basePrice / localizationModule.getPriceToDecimalDivisor());
        this.basePriceHolder.innerHTML = basePriceLabelText;
    }

    updateTotalPriceLabel() {
        const localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
        const sumPriceLabelPrice = this.priceHelper.GetPriceStringWithCurrencySymbol(this.getPackageTotalPrice() / localizationModule.getPriceToDecimalDivisor());
        this.totalPriceHolder.innerHTML = sumPriceLabelPrice;
    }

    updatePriceLabels() {
        this.updateBasePriceLabel();
        this.updateTotalPriceLabel();
    }

    getPackageTotalPrice(): number {
        const optItemsTotalPrice = this.getPriceSumSelectedOptionalItems();
        return (this.basePrice * this.packagesSelectedCount) + optItemsTotalPrice;
    }

    getPackagesSelectedCount(): number {
        return this.packagesSelectedCount;
    }

    getPriceSumSelectedOptionalItems(): number {

        let optItemsTotalPrice = 0;

        for (let i = 0; i < this.optionalItemsSections.length; i++) {
            const optItemSection = this.optionalItemsSections[i];
            optItemsTotalPrice += optItemSection.getSelectedItemsPriceSum();
        }

        return optItemsTotalPrice;
    }

    removeOptionalItemSection() {
        const lastItem = this.optionalItemsSections.pop();
        lastItem.destroyElement();
    }

    getCounterSelectorPack(): string {
        return `.prod__counter_pack_${this.projNr}_${this.prodGroupId}_${this.packageId}_${this.personTypeId}`;
    }

    private addOptionalItemDataAndBasePrice(packageList: any) {
        const packageData = packageList
            .find(x => x.productTripleWithType.id === this.packageId &&
                x.productTripleWithType.productGroupIdentifier === this.prodGroupId);

        for (let i = 0; i < packageData.packageProducts.length; i++) {
            const temp = packageData.packageProducts[i];

            if (!temp.isOptional) {
                this.basePrice += temp.productPrice;
                continue;
            }

            const optionalItem = new RentalDetailsPackOptionSelectionItem(temp.productId, temp.packagePosition, temp.productName, temp.productPrice, temp.preSelected ?? false);
            this.availableOptionalItems.push(optionalItem);
        }
    }

    private manageOptionalItemSection(count: number) {
        const wrapperId = `rental_details__package_optItems_wrapper_${this.projNr}_${this.prodGroupId}_${this.packageId}`;
        const wrapper = document.getElementById(wrapperId);

        if (this.availableOptionalItems.length === 0) {
            return;
        }

        if (count > this.optionalItemsSections.length) {
            const optionalItemSection =
                new RentDetailsProdOptItemSelectSection(this.availableOptionalItems, count > 1, wrapper, this);
            this.optionalItemsSections.push(optionalItemSection);
        } else {
            this.removeOptionalItemSection();
        }
    }

    private initPackageCounters() {
        const axCounter = new AxCounter();

        axCounter.Init({
            Value: 0,
            Selector: this.getCounterSelectorPack(),
            Max: 10,
            Min: 0,
        });

        axCounter.Subscribe((x) => {
            this.packagesSelectedCount = x;
            this.manageOptionalItemSection(x);
            this.updatePriceLabels();
            AxLoad.GetModule<RentalProductDetails>('RentalProductDetails').refreshProceedBtn();
        });
    }
}